import React from "react";

const Testimonials: React.FC = () => (
  <div className="lp-container testimonials">
      <h1>Testimonials</h1>
      <div className="more-test-avail-container">
        <a href="https://www.theknot.com/marketplace/tacboard-chicago-il-1023997" target="_blank">See more reviews on
          <img src="https://tacboard.com/img/knot-btn-img.jpg" /></a>
      </div>

      <div className="testimonialp-box">
        <div className="testimonial-copy-container">
          <p className="message">
            We LOVED how fast we were able to view all of the pictures our
            wedding guests uploaded. We are so grateful to have all of these
            memories. Many of the pictures we may have never seen, so thank you
            TacBoard for making this possible!
          </p>
          <p className="person">Alexis B.</p>
          <p className="from">Pittsburgh, PA</p>
        </div>
        <div className="testimonial-image-container">
          <div className="headshot">
            <img src="https://tacboard.com/img/test-alexis.png" />
          </div>
        </div>
      </div>

      <div className="testimonialp-box">
        <div className="testimonial-copy-container">
          <p className="message">
            Tacboard is great! Fun and easy to use! Our guests loved it.
          </p>
          <p className="person">Jenn and Todd L.</p>
          <p className="from">Chicago, IL</p>
        </div>
        <div className="testimonial-image-container">
          <div className="headshot">
            <img src="https://tacboard.com/img/test-jen.jpg" />
          </div>
        </div>
      </div>

      <div className="testimonialp-box">
        <div className="testimonial-copy-container">
          <p className="message">
            Almost everyone from young to old knows how to text. It seemed like
            an easy way to get our guests to contribute their perspective from
            the day! Indeed, it turned out to be just that.
          </p>
          <p className="person">Alexandra G.</p>
          <p className="from">Cambridge, MA</p>
        </div>
        <div className="testimonial-image-container">
          <div className="headshot">
            <img src="https://tacboard.com/img/test-alexandra2.jpg" />
          </div>
        </div>
      </div>

      <div className="testimonialp-box">
        <div className="testimonial-copy-container">
          <p className="message">
            All our wedding guests were able to use it &amp; could upload the
            pictures they took up to a month after our wedding. We are so
            excited to have our pictures there in one place to look at whenever
            we want! Tacboard is amazing!
          </p>
          <p className="person">Julie L.</p>
          <p className="from">Vancouver, WA</p>
        </div>
        <div className="testimonial-image-container">
          <div className="headshot">
            <img src="https://tacboard.com/img/test-julie.png" />
          </div>
        </div>
      </div>

      <div className="testimonialp-box">
        <div className="testimonial-copy-container">
          <p className="message">
            TacBoard works like a charm! I love this service so much. It's the
            perfect solution for organizing all those valuable candid photos
            your guests are going to take on your wedding day.
          </p>
          <p className="person">Kara Lamerato</p>
          <p className="extra-info">
            Producer &amp; Host of
            <a href="http://weddingplanningpodcast.co/">Wedding Planning Podcast</a>
          </p>
          <p className="from">San Diego, CA</p>
        </div>
        <div className="testimonial-image-container">
          <div className="headshot">
            <img src="https://tacboard.com/img/test-kara.jpg" />
          </div>
        </div>
      </div>

      <div className="testimonialp-box">
        <div className="testimonial-copy-container">
          <p className="message">
            I'm so glad I ran across TacBoard online! We initially wanted to do
            a photo area, but didn't want to have to set up a camera or have a
            stationary photographer there all night. I had pictures from almost
            every guest and it was so easy for everyone to text in their
            pictures and for me to email them to older guests who don't have
            Facebook and who just do email.
          </p>
          <p className="person">Vanessa E.</p>
          <p className="from">Tacoma, WA</p>
        </div>
        <div className="testimonial-image-container">
          <div className="headshot">
            <img src="https://tacboard.com/img/test-vanessa.jpg" />
          </div>
        </div>
      </div>

      <div className="testimonialp-box">
        <div className="testimonial-copy-container">
          <p className="message">
            Tacboard was a great way for our guests to share their candid pics.
            We are so happy to have special shots that could not have been
            captured by the wedding photographer. Our Tacboard pics will be a
            great addition to the wedding photo album.
          </p>
          <p className="person">Lynn M.</p>
          <p className="from">Minneapolis, MN</p>
        </div>
        <div className="testimonial-image-container">
          <div className="headshot">
            <img src="https://tacboard.com/img/test-lynn.jpg" />
          </div>
        </div>
      </div>

      <div className="testimonialp-box">
        <div className="testimonial-copy-container">
          <p className="message">
            We were searching for an option to capture guest photos of a
            wedding, but we needed something simple. Tacboard was the only
            option we found that didn't require our guests to download or sign
            up for anything. The Tacboard staff was easy to work with and even
            expedited shipping on the table tents to make sure they arrived in
            time for the ceremony. Our guests enjoyed watching the live stream
            of photos, and we love looking back on all of the memories that they
            shared. We would recommend highly Tacboard to anybody who is getting
            married.
          </p>
          <p className="person">Brandon T.</p>
          <p className="from">Cleveland, OH</p>
        </div>
        <div className="testimonial-image-container">
          <div className="headshot">
            <img src="https://tacboard.com/img/test-brandon.jpg" />
          </div>
        </div>
      </div>

      <div className="testimonialp-box">
        <div className="testimonial-copy-container">
          <p className="message">
            We got snapshots of the rehearsal day/dinner we didn't even expect.
            It made me wish we had it for the bachelor/bachelorette parties!
          </p>
          <p className="person">Elise G.</p>
          <p className="from">Pittsburgh, PA</p>
        </div>
        <div className="testimonial-image-container">
          <div className="headshot">
            <img src="https://tacboard.com/img/test-elise.jpg" />
          </div>
        </div>
      </div>

      <div className="more-test-avail-container">
        <a href="https://www.theknot.com/marketplace/tacboard-chicago-il-1023997" target="_blank">See more reviews on
          <img src="https://tacboard.com/img/knot-btn-img.jpg" /></a>
      </div>
    </div>
);

export default Testimonials;
